module.exports = __webpack_public_path__ + "img/controlli-standard-emt.68181223.png";